const UI_QUERY_TIMEOUT_MS = 30_000;

/** Follow query cancellation and turn a lost local HTTP response into a retryable error state. */
export function boundedQuerySignal(
  signal: AbortSignal,
  timeoutMs = UI_QUERY_TIMEOUT_MS,
): AbortSignal {
  return AbortSignal.any([signal, AbortSignal.timeout(timeoutMs)]);
}
